import React from 'react'

const Success = () => {
    return (
        <div className='flex justify-center font-pop items-center flex-col gap-2'>
            <img src="../../../../Assets/Prop/deliveredsuccess.png" alt="" className='w-32 md:w-40' />
            <p className='max-w-sm text-center'>Your offer was delivered and accepted by the buyer.</p>
        </div>
    )
}

export default Success